export const fetchDataFromAPI = async (apiCall: () => Promise<any>, defaultItem: any = null) => {
    try {
        const record = await apiCall();
        const results = record ? record : [];
        if (defaultItem) {
            results.push(defaultItem);
        }
        return results;
    } catch (err) {
        console.log(err);
        return [];
    }
};